import { ExpiryModal } from '@zopauk/react-components';
import type { ExpiryModalProps } from '@zopauk/nextjs-auth';

// Temporary: replace with SessionExpiryModal from @zopauk/web-ui when this app moves to Tailwind
export const SessionExpiryModal = ({ isOpen, onKeepSession, onEndSession }: ExpiryModalProps) => (
  <ExpiryModal
    isOpen={isOpen}
    onKeepSession={onKeepSession}
    onEndSession={onEndSession}
    data-automation="ZA.expiry-modal"
  />
);
